import { render } from "./WorstSpeedRestrictions.vue?vue&type=template&id=d95dfda8&scoped=true"
import script from "./WorstSpeedRestrictions.vue?vue&type=script&lang=js"
export * from "./WorstSpeedRestrictions.vue?vue&type=script&lang=js"

import "./WorstSpeedRestrictions.vue?vue&type=style&index=0&id=d95dfda8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95dfda8"]])

export default __exports__